module.exports = __webpack_public_path__ + "img/NL8147520.07caa41a.png";